module.exports = __webpack_public_path__ + "img/ai-chat-btn-new-chat-icon.1e0ec398.svg";